export enum AuthErrorCode {
  'invalid_client' = 'invalid_client',
}
